module.exports = __webpack_public_path__ + "olr-mainfe/styles/bootstrap/fonts/glyphicons-halflings-regular.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/olr-mainfe/styles/bootstrap/fonts/glyphicons-halflings-regular.eot
 ** module id = 42
 ** module chunks = 1
 **/